import { InjectionToken } from '@angular/core';
import { IRendererConfig } from './IRendererConfig';
import { 
  ACTION_STATUS_CONFIG,
  DEFAULT_CONFIG,
  RECOMMENDED_ACTION_CONFIG,
  THREAD_WEAR_TRESHOLD_CONFIG,
  TREAT_MATCHING_ISSUE_CONFIG,
} from './config';

export type RendererConfigProvider =  (displayBy: number) => IRendererConfig;

export const CM_RENDERER_CONFIG = new InjectionToken<RendererConfigProvider>('CM_RENDERER_CONFIG');

export function rendererConfigFactory(): RendererConfigProvider{
  return (displayBy?: number) => {
    switch (displayBy) {
      case 0: return ACTION_STATUS_CONFIG;
      case 1: return RECOMMENDED_ACTION_CONFIG;
      case 2: return THREAD_WEAR_TRESHOLD_CONFIG;
      case 3: return TREAT_MATCHING_ISSUE_CONFIG;
      default: return DEFAULT_CONFIG;
    };
  }
}
